import { Container } from 'inversify'
import { rootContainer } from '~/container'
import { HierarchyReadRepository } from './domain/repositories'
import { HierarchyTree } from './domain/types'
import { HierarchyTreeForPath } from './domain/usecases/HierarchyTreeForPath'
import { AjaxHierarchyReadRepository } from './infrastructure/AjaxHierarchyReadRepository'

export const hierarchiesContainer = new Container()
hierarchiesContainer.parent = rootContainer
hierarchiesContainer
  .bind(HierarchyReadRepository)
  .to(AjaxHierarchyReadRepository)
  .inSingletonScope()
hierarchiesContainer.bind(HierarchyTreeForPath).toSelf()

export async function getHierarchyTree(
  hierarchyPath: string,
  langCode: string,
) {
  const hierarchyTreeGenerator = hierarchiesContainer.get(HierarchyTreeForPath)
  let hierarchyTree: HierarchyTree
  if (hierarchyPath === '/') {
    hierarchyTree = {
      ...(await hierarchyTreeGenerator.execute(hierarchyPath, langCode)),
      label: 'All locations',
    }
  } else {
    const hTree = await hierarchyTreeGenerator.execute(
      removeCityPath(hierarchyPath),
      langCode,
    )
    hierarchyTree = { ...hTree, label: 'All locations' }
  }
  return { hierarchyTree }
}

// export async function getHierarchyTreeName(
//   hierarchyPath: string,
//   langCode: string,
// ) {
//   let selectedHierarchyName: string
//   if (hierarchyPath === '/') {
//     selectedHierarchyName = 'All locations'
//   } else {
//     const hierarchyRepo = hierarchiesContainer.get(HierarchyReadRepository)
//     const [hierarchy] = await Promise.all([
//       hierarchyRepo.readOneByPath(hierarchyPath, langCode),
//     ])
//     selectedHierarchyName = hierarchy.name
//   }
//   return { selectedHierarchyName }
// }

function removeCityPath(url: string) {
  const segments = url.split('/')
  if (segments.length === 5) {
    segments.pop()
    segments.pop()
    return segments.join('/') + '/'
  }
  return url
}

export function getHierarchyRepository() {
  return hierarchiesContainer.get(HierarchyReadRepository)
}
